'use client';

import { Button, Card, CardContent, CardHeader, CardTitle } from '@repo/ui';
import { ArrowLeft } from 'lucide-react';
import Link from 'next/link';
import type { JSX, ReactNode } from 'react';

interface IResourceFormCardProps {
  title: string;
  backHref: string;
  error: string | null;
  isPending: boolean;
  onSubmit: () => void;
  submitLabel: string;
  children: ReactNode;
}

export function ResourceFormCard({
  title,
  backHref,
  error,
  isPending,
  onSubmit,
  submitLabel,
  children,
}: IResourceFormCardProps): JSX.Element {
  return (
    <Card className="mx-auto max-w-4xl">
      <CardHeader>
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" asChild>
            <Link href={backHref}>
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </Button>
          <CardTitle>{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <form
          onSubmit={(e: React.FormEvent) => {
            e.preventDefault();
            onSubmit();
          }}
          className="space-y-4"
        >
          {error && (
            <div className="bg-destructive/10 text-destructive rounded-md p-3 text-sm">{error}</div>
          )}
          <fieldset disabled={isPending} className="space-y-4">
            {children}
          </fieldset>
          <Button type="submit" className="w-full" disabled={isPending}>
            {isPending ? 'Saving...' : submitLabel}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
